(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairStudentsEnrolledController', VirtualFairStudentsEnrolledController);
        VirtualFairStudentsEnrolledController.$inject = ['VirtualFairService', 'ExpoService', '$uibModal'];
    function VirtualFairStudentsEnrolledController(VirtualFairService, ExpoService, $uibModal) {
        var vm = this;

        vm.getAllVirtualFair    = getAllVirtualFair;
        vm.getWhoPays           = getWhoPays;
        vm.getHowMuch           = getHowMuch;
        vm.getProgramTypes      = getProgramTypes;
        vm.getCountries         = getCountries;
        vm.getByFilter          = getByFilter;
        vm.clearForm            = clearForm;
        vm.invite               = invite;
        vm.checkAll             = checkAll;
        vm.downloadCsv          = downloadCsv;
        vm.getPartners          = getPartners;
        vm.activate             = activate;
        
        
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        vm.virtualFairSelected      = [];
        vm.studentName              = '';
        vm.studentEmail             = '';
        vm.confirmed                = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.confirmedSelected        = -1;
        vm.registrationDate         = {startDate: null, endDate: null};
        vm.dateofbirth              = {startDate: null, endDate: null};
        
        vm.countrySelected          = [];
        vm.confirmed                = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.countryFilter            = [{id : 1, name : 'All from'}, {id : 0, name : 'All but'}];
        vm.countryFilterSelected    = 1;
        vm.studentsSelected         = {};
        vm.flag                     = false;
        vm.allChecked               = false;
        vm.partners                 = [];
        vm.partnerSelected          = [];
        vm.programTypesSelected     = [];
        vm.workWhileSelected        = -1;
        vm.workWhile                = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.programSelected          = [];
        vm.budget                   = [0, 10000];
        vm.whoPaysSelected          = [];
        

        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        function getAllVirtualFair () {
            VirtualFairService.getAll().then(function(response) {
                vm.virtualFairs = response.data;
            }).catch(function(err) {
            });
        }

        function getWhoPays () {
            VirtualFairService.whoPays().then(function(response) {
                vm.whoPays = response.data;
            }).catch(function(err) {
            });
        }

        function getHowMuch () {
            VirtualFairService.howMuch().then(function(response) {
                vm.howMuch = response.data;
            }).catch(function(err) {
            });
        }

        function getProgramTypes () {
            VirtualFairService.programTypes().then(function(response) {
                vm.programTypes = response.data;
            }).catch(function(err) {
            });
        }

        function getCountries () {
            VirtualFairService.countries().then(function(response) {
                vm.countries = response.data;
            }).catch(function(err) {
            });
        }

        function clearForm () {
            vm.virtualFairSelected      = [];
            vm.studentName              = '';
            vm.studentEmail             = '';
            vm.confirmedSelected        = -1;
            vm.programTypesSelected     = [];
            vm.registrationDate         = {startDate: null, endDate: null};
            vm.dateofbirth              = {startDate: null, endDate: null};
            vm.countrySelected          = [];
            vm.countryFilterSelected    = 1;
            vm.whoPaysSelected          = [];
        }

        function getByFilter () {
            
            vm.flag = false;
            let query = {};
            query['virtualFairs'] = JSON.stringify(vm.virtualFairSelected);
            query['studentName'] = vm.studentName;
            query['studentEmail'] = vm.studentEmail;
            if (vm.confirmedSelected != -1) {
                query['confirmed'] = vm.confirmedSelected;
            }
            if (vm.programTypesSelected.length > 0) {
                query['program'] =  vm.programTypesSelected;
            }
            if (vm.budget.length > 0) {
                query['budgetMin'] = vm.budget[0];
                query['budgetMax'] = vm.budget[1];
            }
            if (vm.workWhileSelected != -1){
                query['workWhileStudy'] = JSON.stringify(vm.workWhileSelected);
            }
            if (vm.whoPaysSelected.length > 0) {
                query['whoPays'] = JSON.stringify(vm.whoPaysSelected);
            }
            
            query['countryFilter'] = vm.countryFilterSelected;
            query['countrySelected'] = JSON.stringify(vm.countrySelected);
            query['partner'] = JSON.stringify(vm.partnerSelected);
            
            if(vm.registrationDate.startDate !== null && vm.registrationDate.endDate !== null) {
                query['registrationDateStart'] = moment(vm.registrationDate.startDate).format('YYYY-MM-DD 00:00:00');
                query['registrationDateEnd'] = moment(vm.registrationDate.endDate).format('YYYY-MM-DD 23:59:59');
            }
            if(vm.dateofbirth.startDate !== null && vm.dateofbirth.endDate !== null) {
                query['dateofbirthStart'] = moment(vm.dateofbirth.startDate).format('YYYY-MM-DD');
                query['dateofbirthEnd'] = moment(vm.dateofbirth.endDate).format('YYYY-MM-DD');
            }
            query['page'] = vm.page;
            VirtualFairService.getStudentsEnrolled(query).then(function(response) {
                vm.flag = true;
                vm.studentsEnrolled = response.data;
            }).catch(function(err) {
            });
        }


        function downloadCsv () {
            let query = {};
            query['virtualFairs'] = JSON.stringify(vm.virtualFairSelected);
            query['studentName'] = vm.studentName;
            query['studentEmail'] = vm.studentEmail;
            if (vm.confirmedSelected != -1) {
                query['confirmed'] = vm.confirmedSelected;
            }
            if (vm.programTypesSelected.length > 0) {
                query['program'] =  vm.programTypesSelected;
            }
            if (vm.budget.length > 0) {
                query['budgetMin'] = vm.budget[0];
                query['budgetMax'] = vm.budget[1];
            }
            if (vm.workWhileSelected != -1){
                query['workWhileStudy'] = JSON.stringify(vm.workWhileSelected);
            }
            query['confirmed'] = vm.confirmedSelected;
            query['countryFilter'] = vm.countryFilterSelected;
            query['countrySelected'] = JSON.stringify(vm.countrySelected);
            query['partner'] = JSON.stringify(vm.partnerSelected);
            if(vm.registrationDate.startDate !== null && vm.registrationDate.endDate !== null) {
                query['registrationDateStart'] = moment(vm.registrationDate.startDate).format('YYYY-MM-DD 00:00:00');
                query['registrationDateEnd'] = moment(vm.registrationDate.endDate).format('YYYY-MM-DD 23:59:59');
            }
            query['page'] = vm.page;
            VirtualFairService.getStudentsEnrolledCsv(query).then(function(response) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data);
                anchor.target = '_blank';
                anchor.download = 'report_virtual_fairs_students_enrolled.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).catch(function(err) {
            });
        }

        function getPartners () {
            vm.partners = [];
            vm.partnerSelected = [];
            let query = {};
            query['event_id'] = JSON.stringify(vm.virtualFairSelected);
            VirtualFairService.getPartners(query).then(function(response) {
                vm.partners = response.data;
            }).catch(function(err) {
            });
        }

        function invite () {
            let query = {};
            query['students'] = vm.studentsSelected;
            VirtualFairService.sendInviteToStudentsEnrolled(query).then(function(response) {
                alertify.notify('Invitations successfully sended!', 'success', 3);
                vm.allChecked = false;
                vm.checkAll();
            }).catch(function(err) {
            });
        }

        function checkAll () {
            angular.forEach(vm.studentsEnrolled, function(student){ 
                vm.studentsSelected[student.id] = vm.allChecked;
            });
        }

        function getPrograms () {
            VirtualFairService.getPrograms().then(function(response) {
                vm.programs = response.data;
            }).catch(function(err) {
            });
        }

        function activate () {
            vm.getAllVirtualFair();
            vm.getWhoPays();
            vm.getHowMuch();
            vm.getCountries();
            vm.getProgramTypes();
        }

        vm.activate();
    }
})();